import {Component} from "./Component";
import {FormComponent} from "./FormComponent";
import {AjaxNavigation} from "./AjaxNavigation";
import {Tabs} from "../Tabs";

export class Register extends Component {
    static name = "register";

    get name() {
        return Register.name;
    }

    constructor(el) {
        super(el);

        this.tabs = new Tabs(el);

        this.$form = this.$("form");

        this.form = new FormComponent(this.$form, {
            onSubmit: (res) => {
                console.log("LoginForm onSubmit");
                if (res.redirectUrl) {
                    AjaxNavigation.navigate(res.redirectUrl);
                }
            }
        });
    }

}
